import React from 'react'
import './Properties.css'
import PropertiesCard from './PropertiesCard';

import { homes1 } from '../../Exports';
import { homes2 } from '../../Exports';
import { homes3 } from '../../Exports';


function Properties(){
    
   return(
    <div className='Properties'>
      <h3 id='propertyTitle'>Here Are Some of the Properties That I Have Recently Sold</h3>

      <div className='homeSliders'>
          <PropertiesCard images={ homes1.map((home) => home.image)} className="card"/>
          <PropertiesCard images={homes2.map((home) => home.image)} className="card"/>
          <PropertiesCard images={homes3.map((home) => home.image)} className="card"/>
       </div>
    </div>
   );
}

export default Properties;